/**
 * 因为涉及历史数据升级，这里简单记录一下，避免后续同学不知道背景
 * 之前埋点有两部分：
 *  uep：端上维护的一套自动采集埋点方案，部分兼容tracert(有标注场景)，大部分场景独立规范，用户不感知；
 *  tracert：蚂蚁对外统一前端(web&ta)埋点规范
 * 升级：
 *  uep&tracert合二为一，不再分开维护，统一对外输出tracert。
 *  方案：https://yuque.antfin-inc.com/ou303g/yya7ba/crkd45
 * 字段说明：
 *  auto：大多数是uep自动采集
 *  mix：tracert中标注方案，有data-aspm|data-aspm-click之类；
 *  manual：tracert中用户手动调用
 */
export var COMBINE_TYPE = {
  AUTO: 'auto',
  MIX: 'mix',
  MANUAL: 'manual'
};